import React, { useState } from 'react';
import styled from 'styled-components/macro';
import Checkbox from '../Checkbox';
import TermsOfServicePopup from './TermsOfServicePopup';

const TermsOfService = ({ acceptedTOS, onSetAcceptedTOS }) => {
  const [open, setOpen] = useState(acceptedTOS);

  const close = () => setOpen(false);

  return (
    <TermsOfServiceChecker>
      <Checkbox
        checked={acceptedTOS}
        onToggle={() => onSetAcceptedTOS(!acceptedTOS)}
      />
      I agree to the{' '}
      <TermsOfServiceLink onClick={() => setOpen(true)}>
        Terms of Service
      </TermsOfServiceLink>
      .
      {open && (
        <TermsOfServicePopup
          onSetAcceptedTOS={onSetAcceptedTOS}
          close={close}
        />
      )}
    </TermsOfServiceChecker>
  );
};

const TermsOfServiceChecker = styled.div`
  #certiself-form & {
    margin-bottom: 17px;
  }
`;

const TermsOfServiceLink = styled.a`
  #certiself-form & {
    text-decoration: underline;
    cursor: pointer;
  }
`;

export default TermsOfService;
